import { IBrand } from "../types/brands";
import me from "models/me";
import { PermissionRanking, PermissionRole } from "../types/base";
import { hasVerticalAssortmentAccess } from "./vertical-assortments";

export const StopSharing = "STOP_SHARING";
export enum EventType {
    CLICK = "click",
}

export const comparePermissionRoles = (roleA: string, roleB: string, op: string) => {
    if (PermissionRanking[roleA] && PermissionRanking[roleA]) {
        switch (op) {
            case ">":
                return PermissionRanking[roleA] > PermissionRanking[roleB];
            case "<":
                return PermissionRanking[roleA] < PermissionRanking[roleB];
            case ">=":
                return PermissionRanking[roleA] >= PermissionRanking[roleB];
            case "<=":
                return PermissionRanking[roleA] <= PermissionRanking[roleB];
            default:
                break;
        }
    }
    return undefined;
};

export const generateLowerBoundaryRoleMap = (personasData: nuorder.folder.v1.Permission[]) => {
    const inheritedPermissions = personasData.filter((persona) => persona.inherited);
    return (inheritedPermissions || []).reduce((acc, persona) => {
        let newRole = persona.role;
        if (acc[persona.granted_to.member_id]) {
            newRole = comparePermissionRoles(persona.role, acc[persona.granted_to.member_id], ">")
                ? persona.role
                : acc[persona.granted_to.member_id];
        }
        return {
            ...acc,
            [persona.granted_to.member_id]: newRole,
        };
    }, {});
};

export const isMyDriveEnabled = (brand?: IBrand, verticalAssortmentsEnabled?: boolean) => {
    return (
        !me.isBrandUser() ||
        brand?.modules?.drive?.enabled ||
        hasVerticalAssortmentAccess(me, brand, verticalAssortmentsEnabled)
    );
};

export const filterAndSortData = (personasData: nuorder.folder.v1.Permission[]) => {
    const uniquePermissionObj = (personasData || []).reduce((acc, persona) => {
        let permissionData = persona;
        if (acc[persona.granted_to.member_id]) {
            permissionData = comparePermissionRoles(persona.role, acc[persona.granted_to.member_id]?.role, ">")
                ? persona
                : acc[persona.granted_to.member_id];
        }
        return {
            ...acc,
            [persona.granted_to.member_id]: permissionData,
        };
    }, {});
    const uniquePermissions = Object.keys(uniquePermissionObj).map((key) => uniquePermissionObj[key]);
    const owner = uniquePermissions.filter((permission) => permission.role === PermissionRole.Owner) || [];
    const restPermissions =
        uniquePermissions
            .filter((permission) => permission.role !== PermissionRole.Owner)
            .sort((a, b) => {
                const titleA = a.granted_to.display_name.toUpperCase();
                const titleB = b.granted_to.display_name.toUpperCase();
                return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
            }) || [];
    return [].concat(owner, restPermissions);
};
